import * as React from 'react';
import { CircularProgress } from '@material-ui/core';
import { CircularProgressProps } from '@material-ui/core/CircularProgress';

export const LoadingComponent = <CircularProgress />;
export const Loading = (props: Partial<CircularProgressProps>) => <CircularProgress {...props} />;